<template>
  <div class="flex justify-content-start visible-sm">
    <custom-input
      label="Название"
      name="title"
      v-model="searchParams.nameField"
      clear
    />
    <custom-input
      label="Город"
      name="city"
      v-model="searchParams.cityField"
      clear
    />
  </div>
  <div v-if="!loadingTable">
    <ag-grid-vue
      :columnDefs="columnDefs.value"
      :rowData="rowData"
      :rowHeight="70"
      :headerHeight="90"
      :enableCellTextSelection="true"
      :ensureDomOrder="true"
      :pagination="true"
      :paginationPageSize="countOnPage"
      :defaultColDef="defaultColDef"
      :suppressRowHoverHighlight="true"
      :suppressPaginationPanel="true"
      :suppressRowClickSelection="true"
      :suppressRowTransform="true"
      style="width: 100%"
      domLayout="autoHeight"
      @grid-ready="onGridReady"
      @filterChanged="filterChanged"
    ></ag-grid-vue>

    <table-pagination
      :gridApi="gridApi"
      :totalPages="gridApi ? gridApi.paginationGetTotalPages() : 0"
      :countOnPage="countOnPage"
      :activeFilter="activeFilter"
    />
  </div>
  <div v-else class="table-preloader">
    <preloader />
  </div>
</template>

<script>
import VPagination from "@hennge/vue3-pagination";
import "ag-grid-community/dist/styles/ag-grid.css";
import { AgGridVue } from "ag-grid-vue3";
import { reactive, ref } from "@vue/reactivity";
import EditRenderer from "@/components/Tables/CellRenderers/EditRenderer.vue";
import ImageRenderer from "@/components/Tables/CellRenderers/ImageRenderer.vue";
import NewPartnerRenderer from "@/components/Tables/CellRenderers/NewPartnerRenderer.vue";
import { useStore } from "vuex";
import { computed, onBeforeMount, watch } from "@vue/runtime-core";
import Preloader from "@/components/Technical/Preloader.vue";
import CustomTextFilter from "@/components/Tables/FiltersComponents/CustomTextFilter.vue";
import TextLinkRenderer from "@/components/Tables/CellRenderers/TextLinkRenderer.vue";
import UserLink from "@/components/Tables/CellRenderers/UserLink.vue";
import CustomInput from "@/components/Forms/Fields/CustomInput.vue";
import TablePagination from "@/components/OtherElements/TablePagination.vue";
import CustomSelectFilter from "@/components/Tables/FiltersComponents/CustomSelectFilter.vue";
export default {
  name: "partners-table",
  components: {
    VPagination,
    AgGridVue,
    EditRenderer,
    ImageRenderer,
    Preloader,
    TextLinkRenderer,
    CustomInput,
    CustomTextFilter,
    TablePagination,
    CustomSelectFilter,
    NewPartnerRenderer,
    UserLink,
  },
  setup() {
    const store = useStore(),
      gridApi = ref(null),
      columnApi = ref(null);

    const onGridReady = (params) => {
      gridApi.value = params.api;
      columnApi.value = params.columnApi;
      columnApi.value.applyColumnState({
        state: [{ colId: "new", sort: "desc" }],
      });
    };
    const countOnPage = ref(15),
      activeFilter = ref(false),
      isPreloader = ref(false),
      searchParams = reactive({
        nameField: "",
        cityField: "",
      });
    const loadingTable = computed(() => store.state.ui.loadingTable);
    const partners = computed(() => store.state.partners.centers),
      rowData = computed(() => {
        return partners.value.map((partner) => {
          return {
            id: partner.id,
            title: partner.title,
            city: partner.city ? partner.city.name : "",
            edit: partner.id,
            type:
              partner.type && partner.type === "expert"
                ? "Эксперт"
                : "Тренинговый центр",
            new: partner.status,
            image: partner.image,
            user: partner.user.name,
            user_id: partner.user.id,
          };
        });
      });

    const columnDefs = reactive({
      value: [
        {
          field: "id",
          hide: true,
        },
        {
          field: "new",
          headerName: "",
          width: 160,
          flex: 0,
          cellRenderer: "NewPartnerRenderer",
        },
        {
          field: "image",
          headerName: "Фото",
          maxWidth: 75,
          flex: 0,
          cellRenderer: "ImageRenderer",
        },
        {
          field: "title",
          headerName: "Название",
          wrapText: true,
          minWidth: 255,
          cellRenderer: "TextLinkRenderer",
          cellRendererParams: {
            source: "partner",
          },
          filter: "CustomTextFilter",
          sortable: true,
          filterParams: {
            filterName: "Поиск по названию",
          },
        },
        {
          field: "city",
          headerName: "Город",
          wrapText: true,
          minWidth: 200,
          filter: "CustomTextFilter",
          filterParams: {
            filterName: "Поиск по городу",
          },
        },
        {
          field: "user",
          headerName: "Пользователь",
          wrapText: true,
          minWidth: 200,
          filter: "CustomTextFilter",
          cellRenderer: "UserLink",
          filterParams: {
            filterName: "Поиск по пользователям",
          },
          cellRendererParams: {
            source: "user_id",
            type: "staff",
          },
        },
        {
          field: "edit",
          headerName: "",
          width: 70,
          flex: 0,
          cellRenderer: "EditRenderer",
          cellRendererParams: {
            source: "partner",
          },
        },
      ],
    });
    const defaultColDef = {
      suppressMovable: true,
      flex: 1,
      autoHeight: true,
    };

    onBeforeMount(() => {
      store.commit("ui/setLoadingTable", true);
      store
        .dispatch("partners/getCenters")
        .finally(() => store.commit("ui/setLoadingTable", false));
    });

    watch(searchParams, () => {
      if (
        searchParams.nameField.length >= 3 ||
        searchParams.cityField.length >= 3
      ) {
        gridApi.value.setQuickFilter(
          `${
            searchParams.nameField.length >= 3 ? searchParams.nameField : ""
          } ${searchParams.cityField.length >= 3 ? searchParams.cityField : ""}`
        );
      } else {
        gridApi.value.setQuickFilter(null);
      }
    });

    const filterChanged = () => {
      activeFilter.value = !activeFilter.value;
    };

    return {
      countOnPage,
      isPreloader,
      partners,
      searchParams,
      activeFilter,
      loadingTable,

      columnDefs,
      rowData,
      defaultColDef,
      gridApi,
      onGridReady,
      columnApi,
      filterChanged,
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
